const config = {"region":"eu-central-1","apiUrl":"https://r0qw9hvj67.execute-api.eu-central-1.amazonaws.com/","userPoolId":"eu-central-1_J5oddr41h","userPoolWebClientId":"75uoc3jcnc5phr56al8ddeqj73","authenticationFlowType":"USER_PASSWORD_AUTH"};

export default config;

